.list {
  display: flex;
  gap: 4px;
  border-block-end: 1px solid var(--color-border);
  overflow-x: auto;
}
.tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding-inline: 14px;
  border: 0;
  background: transparent;
  color: var(--color-text-muted);
  font-weight: 600;
  font-size: 0.9375rem;
  cursor: pointer;
  border-block-end: 2px solid transparent;
  margin-block-end: -1px;
  white-space: nowrap;
}
.tab:hover:not(:disabled) {
  color: var(--color-text);
}
.tab:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.active {
  color: var(--color-text);
  border-block-end-color: var(--color-accent);
}
.count {
  font-size: var(--text-xs);
  /* Pastille visible sur le fond de page (neutral-soft = couleur du fond en clair). */
  background: var(--color-accent-soft);
  color: var(--color-accent-ink);
  font-weight: 700;
  border-radius: var(--radius-pill);
  padding: 1px 8px;
}
.panel {
  padding-block-start: var(--space-5);
}
